module.exports = __webpack_public_path__ + "img/logo_real-estate.7fc17225.svg";